import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'components/ui';

class ConfirmDelete extends Component {
  handleConfirmation = () => {
    this.props.onConfirm();
  };

  handleCancel = () => {
    this.props.onHide();
  };

  render() {
    const { title, description, isVisible } = this.props;
    return (
      <Modal
        visible={isVisible}
        onCancel={this.handleCancel}
        onOk={this.handleConfirmation}
      >
        <div>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </Modal>
    );
  }
}

ConfirmDelete.defaultProps = {
  title: 'Delete item!',
  description: 'You are about to delete this item. Do you wish to proceed?',
};

ConfirmDelete.propTypes = {
  description: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ConfirmDelete;
